'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createDispatch;
function createDispatch() {
    var fixture = {};

    return {
        setAsap: function setAsap() {
            delete fixture.timeGuarantee;
            delete fixture.time;
            return this;
        },
        setFutureOrder: function setFutureOrder() {
            fixture.timeGuarantee = 'about';
            return this;
        },
        setDispatchTime: function setDispatchTime(timestamp) {
            fixture.time = timestamp;
            return this;
        },
        setPickup: function setPickup() {
            fixture.type = 'takeout';
            fixture.address = null;
            return this;
        },
        setDelivery: function setDelivery(address) {
            fixture.type = 'delivery';
            fixture.address = address;
            return this;
        },
        val: function val() {
            return fixture;
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-restaurants-js-sdk/dist/fixtures/Dispatch.js
// module id = 718
// module chunks = 0